import locale from 'date-fns/locale/en-US';
import { format } from 'date-fns';
import moment from 'moment';

export const DATE_FORMATED = {
  'dd/MM/yyyy': 'dd/MM/yyyy',
  'MM/dd/yyyy': 'MM/dd/yyyy',
  'dd/MM/yyyy HH:mm:ss': 'dd/MM/yyyy HH:mm:ss',
  'dd/MM/yyyy HH:mm': 'dd/MM/yyyy HH:mm',
  'dd//MM': 'dd//MM',
  dd: 'dd',
  MM: 'MM',
  'HH:mm': 'HH:mm',
};

const formatDistanceLocale = {
  lessThanXSeconds: '{{count}}s',
  xSeconds: '{{count}}s',
  halfAMinute: '30s',
  lessThanXMinutes: '{{count}}m',
  xMinutes: '{{count}}m',
  aboutXHours: '{{count}}h',
  xHours: '{{count}}h',
  xDays: '{{count}}d',
  aboutXWeeks: '{{count}}w',
  xWeeks: '{{count}}w',
  aboutXMonths: '{{count}}m',
  xMonths: '{{count}}m',
  aboutXYears: '{{count}}y',
  xYears: '{{count}}y',
  overXYears: '{{count}}y',
  almostXYears: '{{count}}y',
};

export const customLocale = {
  ...locale,
  formatDistance: (token, count, options) => {
    options = options || {};

    const result = formatDistanceLocale[token].replace('{{count}}', count);

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result;
      } else {
        return result + ' ago';
      }
    }

    return result;
  },
};

export const formatDateBy = (unixTimestamp) => {
  const date = new Date(unixTimestamp * 1000);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatDateToString = (unixTimestamp, typeDate) => {
  const date = new Date(unixTimestamp * 1000);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  switch (typeDate) {
    case DATE_FORMATED['dd/MM/yyyy HH:mm:ss']:
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    case DATE_FORMATED['dd/MM/yyyy HH:mm']:
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    case DATE_FORMATED['dd//MM']:
      return `${day}/${month}`;
    case DATE_FORMATED['HH:mm']:
      return `${hours}:${minutes}`;
    case DATE_FORMATED['dd']:
      return `${day}`;
    case DATE_FORMATED['MM']:
      return `${month}`;
    default:
      return `${month}/${day}/${year}`;
  }
};

export const convertMMtoHHMM = (minutes) => {
  const hour = Math.floor(minutes / 60);
  const min = minutes % 60;
  return { hour, min };
};

export const formatDate = (seconds, formatBy = 'dd/MM/yyyy HH:mm:ss') => {
  if (!seconds) {
    return '';
  }
  // Convert to milliseconds
  return format(seconds * 1000, formatBy);
};

export const currentDate = (formatBy = 'dd/MM/yyyy HH:mm:ss') => {
  const myDate = moment(Date.now());
  const milliseconds = myDate.unix() * 1000;
  // Convert to milliseconds
  return format(milliseconds, formatBy);
};

export const getSeconds = (value) => {
  // Return 0 if the value is falsy (e.g., null, undefined, or empty string)
  if (!value) {
    return 0;
  }
  // value is 0 = 1/1/2000, 12:00:00 AM

  const myDate = moment(value);
  if (!myDate.isValid()) {
    return 0; // Return 0 if the input is an invalid date
  }

  const seconds = myDate.unix();
  return seconds;
};

export const currentToDate = () => {
  const myDate = moment(Date.now());
  return myDate.toDate();
};

export const formatToDate = (seconds, format) => {
  // Multiply by 1000 to convert seconds to milliseconds for Moment.js
  const myDate = moment(seconds * 1000);
  if(format){
    // Correct format string: DD/MM/yyyy HH:mm:ss
    return myDate.format(format.replace('dd', 'DD').replace('yyyy', 'YYYY'));  // Return formatted date string
  }
  return myDate.toDate(); // Return Date object
};

export const formatToSeconds = (timestamp) => {
  // Mon Apr 14 2025 17:13:58 GMT+0700
  const date = new Date(timestamp);
  return Math.floor(date.getTime() / 1000);
};

export const parseTimeInfo = (milliseconds) => {
  const date = new Date(milliseconds);
  
  // Get day of week
  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const dayOfWeek = daysOfWeek[date.getDay()];

  // Check overtime (from 19:00)
  const hour = date.getHours();
  const minute = date.getMinutes();

  let overtime = 0;
  if (hour >= 19) {
    // Overtime in hours (float), you can floor/round if needed
    overtime = (hour + minute / 60) - 19;
  }

  return {
    dayOfWeek,
    overtime: parseFloat(overtime.toFixed(2)) // rounded to 2 decimal places
  };
}

export const currentSeconds = () => {
  const seconds = Math.floor(Date.now() / 1000);
  return seconds;
};
